// Imported Rating Method from ECV 1.5

import Filters from "./filters";

function standardDeviation(arr) {
    let i, j, total = 0, mean = 0;
    for (i = 0; i < arr.length; i += 1) {
        total += arr[i];
    }
    mean = total / arr.length;
    total = 0;
    for (j = 0; j < arr.length; j += 1) {
        total += Math.pow((arr[j] - mean), 2);
    }
    return (Math.sqrt(total / arr.length));
}

function photoRater(context, takePhotoCanvas) {
    const imageData = context.getImageData(0, 0, takePhotoCanvas.width, takePhotoCanvas.height);
    const laplacedImage = Filters.laplace(Filters.grayscale(imageData));
    let arr = [];

    for (let j = 0; j < laplacedImage.data.length; j += 4){
        arr.push(laplacedImage.data[j]);
    }

    return standardDeviation(arr);
}

export default photoRater;